module.exports = __webpack_public_path__ + "img/img_quanyi01@2x.52aa002e.png";